import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EntityTypes } from '@guryou/core';
import { getServices, PROVIDER_SERVICES_GET_MANY, resetState, StateStatus } from '@guryou/redux';

const useServices = stateSelector => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(stateSelector);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getServices(EntityTypes.service));
    }
  }, [dispatch, status]);

  useEffect(() => {
    return () => dispatch(resetState(PROVIDER_SERVICES_GET_MANY));
    //eslint-disable-next-line
  }, []);

  return { data: data || [], status, version, entity };
};

export default useServices;
